export default __webpack_public_path__ + "static/media/016-microwave.8f576ac9.svg";